<template>
  <div class="is-flex is-flex-direction-column is-align-items-end">
    <div class="my-1">
      <Checkbox :checked="data.isWhatsappCheck" :value="data.isWhatsappCheck" @input="(e) => { data.isWhatsappCheck = e; validate() }">העתקת כלל שיחות הוואטסאפ למערכת</Checkbox>
    </div>
    <div class="my-1">
      <Checkbox :checked="data.isOpenTasks" :value="data.isOpenTasks" @input="(e) => { data.isOpenTasks = e; validate() }">מעבר על העניינים הפתוחים שלי</Checkbox>
    </div>
  </div>
</template>
<script>
import Checkbox from './Checkbox.vue'

export default {
  name: 'FeedContentMorningRoutine',
  components: {
    Checkbox
  },
  data () {
    return {
      data: {
        isOpenTasks: false,
        isWhatsappCheck: false
      }
    }
  },
  methods: {
    validate () {
      const isValid = Object.entries(this.data).reduce((prev, [k, v]) => {
        return prev && v
      }, true)
      this.$emit('input', isValid)
    }
  }
}
</script>
